import { Label } from '@cian/ui-kit';

import { type FC } from 'react';

export const FromOwnerLabelContainer: FC = () => {
  return (
    <Label
      background="surface-positive-default"
      color="text-positive-default"
      data-testid="publisher-labels.from-owner"
    >
      Собственник
    </Label>
  );
};
